import { createSelector } from 'reselect';

const getkiplingerRegistration = (state) => state.kiplingerRegistration || {};

export const getKiplingerRegistrationUrl = createSelector(
  getkiplingerRegistration,
  (response) =>
    response && response.kiplingerRegistrationUrl
      ? response.kiplingerRegistrationUrl
      : null
);
